"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var horizontalSpace = 2;
var borderWidth = 1;

var base = function base(_ref) {
  var theme = _ref.theme,
      switchHeight = _ref.switchHeight,
      switchWidth = _ref.switchWidth,
      circleSize = _ref.circleSize,
      switchDistance = _ref.switchDistance;
  return /*#__PURE__*/(0, _react.css)("display:inline-flex;align-items:center;label{cursor:pointer;display:flex;align-items:flex-start;&>span{display:inline-block;vertical-align:middle;&+*{margin-left:", (0, _util.rem)(8), ";}&::after{content:'-';visibility:hidden;width:0;display:inline-block;vertical-align:middle;}}.switch-btn{position:relative;display:inline-block;vertical-align:middle;width:", (0, _util.rem)(switchWidth), ";height:", (0, _util.rem)(switchHeight), ";color:", theme.color.monochrome.mediumDark, ";border:", borderWidth, "px solid currentColor;border-radius:", (0, _util.rem)(Math.floor(switchHeight / 2)), ";transition:border 0.2s ease-in-out;background-color:", theme.color.monochrome.white, ";flex-shrink:0;&::after{content:'';width:", (0, _util.rem)(circleSize), ";height:", (0, _util.rem)(circleSize), ";background-color:currentColor;border-radius:50%;position:absolute;top:50%;left:", (0, _util.rem)(horizontalSpace), ";transform:translateX(0) translateY(-50%);transition:transform 0.2s ease-in-out;}}}input{display:none;&:checked+label .switch-btn{color:", theme.color.primary.positive, ";&::after{transform:translateX(", (0, _util.rem)(switchDistance), ") translateY(-50%);}}&:disabled+label{cursor:initial;}&:disabled:not(:checked)+label .switch-btn{color:", theme.color.monochrome.medium, ";}&:disabled:checked+label>span{opacity:0.5;}}svg{width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";vertical-align:middle;color:", theme.color.primary.brand, ";outline:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var primary = function primary(_ref2) {
  var theme = _ref2.theme,
      switchHeight = _ref2.switchHeight,
      switchWidth = _ref2.switchWidth,
      innerSpace = _ref2.innerSpace;
  var circleSize = switchHeight - innerSpace * 2;
  var switchDistance = switchWidth - circleSize - (horizontalSpace + borderWidth) * 2;
  return base({
    theme: theme,
    switchHeight: switchHeight,
    switchWidth: switchWidth,
    circleSize: circleSize,
    switchDistance: switchDistance
  });
};

var secondary = function secondary(props) {
  return /*#__PURE__*/(0, _react.css)(primary(props), ";input:checked+label .switch-btn{color:", props.theme.color.primary.info, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:secondary;"));
};

var types = {
  primary: primary,
  secondary: secondary
};
var styles = {
  types: types
};
exports.styles = styles;
//# sourceMappingURL=Switch.styles.js.map